import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { sizes } from '../breakpoints';
import { GridRowContext } from './context';
import { getPx } from '../helpers/common';
import { isDefined } from '../helpers/defined';
import { filterProps } from '../helpers/props';
import { filterValues } from '../helpers/values';
import { modifyKeys, omitKeys } from '../helpers/keys';
import { spreadByBreakpoints } from '../helpers/media-spread';
import { styleArrayForBreakpoints } from '../helpers/media-style';
import { order } from '../style/order';
import { paddingHalfVertical } from '../style/padding-vertical';
import { paddingHalfHorizontal } from '../style/padding-horizontal';

var addOffset = function addOffset(key) {
  return key + "Offset";
};

var removeOffset = function removeOffset(key) {
  return key.replace(/Offset$/, '');
};

var offsetSizes = sizes.map(addOffset);

var hasOffset = function hasOffset(key) {
  return offsetSizes.includes(key);
};

var StyledDiv = styled.div(_templateObject(), function (_ref) {
  var $gutter = _ref.$gutter;
  return paddingHalfHorizontal($gutter);
}, function (_ref2) {
  var $spacing = _ref2.$spacing;
  return paddingHalfVertical($spacing);
}, function (_ref3) {
  var $columns = _ref3.$columns,
      $size = _ref3.$size,
      $offset = _ref3.$offset,
      $width = _ref3.$width;
  return styleArrayForBreakpoints([$columns, $size, $offset, $width], function (_ref4) {
    var $columns = _ref4[0],
        $size = _ref4[1],
        $offset = _ref4[2],
        $width = _ref4[3];
    return (
      /* prettier-ignore */
      isDefined($width) ? "\n          width: " + getPx($width) + ";\n          flex-grow: 0;\n          flex-shrink: 0;\n        " : $size === true || !isDefined($size) ? "\n          max-width: 100%;\n          flex-basis: 0;\n          flex-grow: 1;\n        " : $size === false ? "\n          display: none;\n        " : "\n          max-width: calc(100% / " + $columns + " * " + $size + ");\n          flex-basis: calc(100% / " + $columns + " * " + $size + ");\n          margin-left: calc(100% / " + $columns + " * " + ($offset != null ? $offset : 0) + ");\n        "
    );
  }, false);
}, function (_ref5) {
  var $order = _ref5.$order;
  return isDefined($order) ? order($order) : '';
});
var SIZE_PROP = {
  xs: true
};
var OFFSET_PROP = {
  xs: 0
};

var GridCol = function GridCol(_ref6) {
  var widthProp = _ref6.width,
      _ref6$size = _ref6.size,
      sizeProp = _ref6$size === void 0 ? SIZE_PROP : _ref6$size,
      _ref6$offset = _ref6.offset,
      offsetProp = _ref6$offset === void 0 ? OFFSET_PROP : _ref6$offset,
      order = _ref6.order,
      props = _objectWithoutPropertiesLoose(_ref6, ["width", "size", "offset", "order"]);

  var _useContext = useContext(GridRowContext),
      gutter = _useContext.gutter,
      spacing = _useContext.spacing,
      columnsProp = _useContext.columns;

  var sizeDirectProps = useMemo(function () {
    return filterProps(props, function (key) {
      return sizes.includes(key);
    });
  }, [props]);
  var offsetDirectProps = useMemo(function () {
    return modifyKeys(filterProps(props, hasOffset), removeOffset);
  }, [props]);
  var size = useMemo(function () {
    return _objectSpread(_objectSpread({}, spreadByBreakpoints(sizeProp, true)), filterValues(spreadByBreakpoints(sizeDirectProps, true), isDefined));
  }, [sizeProp, sizeDirectProps]);
  var offset = useMemo(function () {
    return _objectSpread(_objectSpread({}, spreadByBreakpoints(offsetProp, true)), filterValues(spreadByBreakpoints(offsetDirectProps, true), isDefined));
  }, [offsetProp, offsetDirectProps]);
  var columns = useMemo(function () {
    return spreadByBreakpoints(columnsProp, true);
  }, [columnsProp]);
  var width = useMemo(function () {
    return spreadByBreakpoints(widthProp, true);
  }, [widthProp]);
  var restProps = useMemo(function () {
    return omitKeys(props, [].concat(sizes, offsetSizes));
  }, [props]);
  return /*#__PURE__*/React.createElement(StyledDiv, _extends({
    $size: size,
    $offset: offset,
    $columns: columns,
    $gutter: gutter,
    $spacing: spacing,
    $width: width,
    $order: order
  }, restProps));
};

export default GridCol;